<div *ngIf="form !== undefined" [formGroup]="form">
    <input type="{{type}}" (keyup.enter)="onEnter()" [formControlName]="name" [placeholder]="placeholder"
        [(ngModel)]="input" (ngModelChange)="onChangeProperty($event)" autocomplete="off" [style.backgroundImage]="'url(' + icon + ')'" [readonly]="readonly" [class.readonly]="readonly">
</div>
<div *ngIf="form === undefined">
    <input type="{{type}}" (keyup.enter)="onEnter()" [placeholder]="placeholder"
        [(ngModel)]="input" (ngModelChange)="onChangeProperty($event)" autocomplete="off" [style.backgroundImage]="'url(' + icon + ')'" [readonly]="readonly" [class.readonly]="readonly">
</div>
